import { Box, Grid, Link, Typography } from "@mui/material";
import React from "react";
import profilePic from "../../assets/headshot.png";
import { Link as ReactRouterLink } from "react-router-dom";

export default function AboutSection() {
  return (
    <Grid container maxWidth="md" spacing={4}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: { xs: "center", md: "flex-start" },
        }}
      >
        <Box
          component="img"
          src={profilePic}
          alt="Will, founder of Curate"
          sx={{
            borderRadius: "50%", // circular crop
            maxWidth: { xs: 250, md: 300 },
            maxHeight: { xs: 250, md: 300 },
            // mb: { xs: 4, md: 4 },
          }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Box
          sx={
            {
              // maxWidth: { xs: "250px", sm: "300px", md: "500px" },
              // textAlign: "justify",
            }
          }
        >
          <Typography variant="h3" color="text.primary" gutterBottom>
            <b>About</b>
          </Typography>
          <Typography gutterBottom>
            <b>Hello! My name’s Will</b> 👋 I’m an avid reader and movie
            enthusiast. For years, I’ve kept various lists in my phone’s notes
            app to track everything I've been watching and reading, as well as
            recommendations from friends and family.
          </Typography>
          <Typography gutterBottom>
            <b>Why not use existing apps? </b>The truth is, I did. But nothing
            really provided the simplicity, lack of friction and breadth of
            content I was after. Goodreads is a great idea, but it’s horrible to
            use. Letterboxd is a step in the right direction, but it’s just for
            movies.
          </Typography>
          <Typography gutterBottom>
            <b>And so the idea of Curate was born: </b> a single place to curate
            movies, TV shows and books that is (hopefully!) elegant, simple and
            joyful to use.
          </Typography>
          {/* <Typography gutterBottom>
            <b>Curate is a passion project, not a business. </b> I’m funding it
            myself and my only goal is to make the app I wished existed in the
            first place. So, if you’re the type of person who thrives on sharing
            and receiving recommendations, delights in experiencing the best of
            what they’re passionate about and loves the satisfaction of ticking
            items off their “to watch / read / listen / see” lists, Curate may
            well be for you too.
          </Typography> */}
          <Typography sx={{ mt: 1, fontStyle: "italic" }}>
            Check out my Curate profile:{" "}
            <Link component={ReactRouterLink} to={`/u/will`}>
              <b>@will</b>
            </Link>{" "}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}
